import React from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { delet, resetDeleteState, selectDeleteOperateSuccessState } from '../../../redux/operate/operate-delete-slice';

const DeleteService = ({ service, closeButtomSheetHandler }) => {
    const dispatch = useDispatch();
    // const deleteSuccess = useSelector(selectDeleteOperateSuccessState);
    // پیام با Toast
    // const message = (msg, type) => {
    //     if (type === 'warn') toast.warning(msg);
    //     else toast.success(msg);
    //   };
    // const message = (msg, type) => {
    //   if (type === 'warn') {
    //     toast.warning(msg, {
    //       autoClose: 3000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //     });
    //   } else {
    //     toast.success(msg, {
    //       autoClose: 3000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //     });
    //   }
    // };
  
    // useEffect(() => {
    //   if (deleteSuccess) {
    //     message('سرویس مورد نظر با موفقیت حذف گردید.', 'success');
    //     dispatch(resetDeleteState());
    //     closeButtomSheetHandler();   // 👈 حالا بعد از موفقیت ببند
    //   }
    // }, [deleteSuccess, dispatch]);
  
    const serviceDeleteHandler = () => {
      dispatch(delet(service));
      closeButtomSheetHandler();
    };
  
    const handleClose = () => {
      closeButtomSheetHandler();
    };
  
    return (
      <div className="container">
        <span>آیا از حذف سرویس <strong>{service.ok_title}</strong> در خودروی <strong>{service.car_title}</strong> اطمینان دارید؟</span>
        <br /><br />
        <div className="container px-4">
          <div className="row gx-5">
            <div className="col">
              <div className="p-1">
                <div className="row row-cols-1">
                  <button onClick={serviceDeleteHandler} className="btn btn-outline-success" type="button">
                    بلی
                  </button>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="p-1">
                <div className="row row-cols-1">
                  <button onClick={handleClose} className="btn btn-outline-danger" type="button">
                    خیر
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default DeleteService